module.exports = __webpack_public_path__ + "static/media/cordapp.75b55d32.png";